const dynamicURL = `${location.protocol}//${location.hostname}${location.port ? ':'+location.port: ''}/v1x`;

const apiURL = process?.env?.isProd ? dynamicURL : 'https://telemetry.svc.utto.io/v1x';
console.log(`using api: ${apiURL}`);

const getToken = () => {
  return localStorage.getItem('token');
}

const GET = (ep) => {
  var xhr = new XMLHttpRequest();
  var url = apiURL + ep;

  return new Promise((resolve, reject) => {
    try {
      xhr.open("GET", url, true);
      xhr.responseType = 'json';
      xhr.setRequestHeader("X-API-Token", getToken());
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve(xhr.response);
        } else if (xhr.status === 403 || xhr.status === 401) {
          localStorage.removeItem('token');
          reject(xhr.response);
        }
      };
      xhr.send();
    } catch(err) {
      reject(err);
    }
  });
};

export default {
  GET,
  getToken,
}
